function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18ea95;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1.03 0.974)"
}, React.createElement("path", {
  className: "a",
  d: "M-2038.118,2132.1V2084.7l19.527-5.917v47.409Zm.321-47.171v46.739l18.886-5.722v-46.739Z",
  transform: "translate(2038.118 -2078.779)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(20.236 0.974)"
}, React.createElement("path", {
  className: "a",
  d: "M-1928.735,2132.1l-19.527-5.917v-47.409l19.527,5.917Zm-19.206-6.154,18.886,5.722v-46.739l-18.886-5.722Z",
  transform: "translate(1948.262 -2078.779)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(39.443 0.974)"
}, React.createElement("path", {
  className: "a",
  d: "M-1858.406,2132.1V2084.7l19.527-5.917v47.409Zm.321-47.171v46.739l18.886-5.722v-46.739Z",
  transform: "translate(1858.406 -2078.779)"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 5.82)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 52.893)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(38.413 5.82)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(38.413 52.893)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(19.207)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(19.207 47.021)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(57.62)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(57.62 47.021)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("rect", {
  className: "a",
  width: 2.38,
  height: 2.38,
  transform: "translate(0 2.38) rotate(-90)"
})));

var SvgHmrMaps = function SvgHmrMaps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 55.274,
    viewBox: "0 0 60 55.274",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHmrMaps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hmr_maps.9ad2699f.svg";
export { ForwardRef as ReactComponent };